store.admin.overlayElementsLabel = 'asdf';
store.admin.overlayElements = function(className) {
	var n = { top: 99999, left: 99999, width: 0, height: 0, wrapper: null},
		areas = {},
		currentArea = 0;

	$('.elementOverlay').remove();
	$('.overlayElementLabel').remove();
	$('.' + className).each(function(){
		var t = $(this);
		//var off = t.offset();
		var pos = t.position();
		if (pos.top === 0) return;
		var oWidth = t.outerWidth(true)+pos.left;
		var oHeight = t.outerHeight(true)+pos.top;

		if (!areas[currentArea]) {
			areas[currentArea] = jQuery.extend({}, n);
		}

		var a = areas[currentArea];
		if (!a.wrapper) a.wrapper = t.parent();
		if (pos.top < a.top) a.top = pos.top;
		if (pos.left < a.left) a.left = pos.left;
		if (oWidth > a.width) a.width = oWidth;
		if (oHeight > a.height) a.height = oHeight;
		$('input', this).attr('disabled', 'disabled');

		var nex = t.next();
		if (!nex.hasClass(className)) {
			++currentArea;
		}
	});

	for (var i in areas) {
		//noinspection JSUnfilteredForInLoop
		var a = areas[i];
		var p = $('<p class="overlayElementLabel">' + store.admin.overlayElementsLabel + '</p>')
			.css('position', 'absolute')
			.css('left', a.left-2 + 'px')
			.prependTo(a.wrapper);
		var o = $('<div class="elementOverlay"/>')
			.css('position', 'absolute')
			.css('top', a.top + 'px')
			.css('left', a.left + 'px')
			.css('width', a.width - a.left + 'px')
			.css('height', a.height - a.top + 'px')
			.prependTo(a.wrapper);
		p.css('margin-left', (o.outerWidth()/2) - (p.outerWidth()/2) + 'px');
		var x = (a.top-10) + (o.outerHeight()/2) - (p.outerHeight()/2);
		p.css('top', x + 'px');
	}
};
